import { InjectionToken } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

export type WnlHostType = 'input' | 'checkbox-group' | 'checkbox';

export interface WnlHostControl {
  getWnlControl(): UntypedFormControl | null;
  getWnlHostType(): WnlHostType;
  isWnlSelectInput?(): boolean;
}

export const WNL_HOST_CONTROL = new InjectionToken<WnlHostControl>('WNL_HOST_CONTROL');
